import { fetchClient } from './fetchClient';
import requestEndpoints from './requestEndpoints';

export const addToCart = async (
  materials: Record<string, any>,
  bagProject: Record<string, any> | null,
) => {
  try {
    const params = new URLSearchParams();

    // @ts-expect-error // TODO: fix types
    materials.forEach((item, index) => {
      params.append(`product_id[${index}]`, item.id);
      params.append(`qty[${index}]`, '1');
      params.append(
        `project_name[${index}]`,
        bagProject?.title || bagProject?.project_title,
      );
      params.append(
        `project_type[${index}]`,
        String(
          bagProject?.type?.externalId?.toString() ||
            bagProject?.project_type ||
            0,
        ),
      );
      params.append(
        `project_id[${index}]`,
        bagProject?.externalId?.toString() ||
          String(bagProject?.project_id || 0),
      );

      if (item?.itemListId != null) {
        params.append(`item_list_id[${index}]`, item?.itemListId);
      }

      if (item?.itemListName != null) {
        params.append(`item_list_name[${index}]`, item?.itemListName);
      }

      if (item?.is_diverzify != null) {
        params.append(`is_diverzify[${index}]`, item?.is_diverzify);
      }

      params.append(`index[${index}]`, String(item?.index || index + 1));
    });

    const { data } = await fetchClient.post(
      requestEndpoints.addToBag(),
      params,
    );

    return data;
  } catch (error) {
    console.log('Error while checking stock >>> ', error.message);

    return null;
  }
};

export const saveDealer = async (dealerName: string | null) => {
  const { data } = await fetchClient.post(requestEndpoints.save3MDealer(), {
    dealer: dealerName,
  });
  return data;
};
